import React from 'react';

var Product = function Product(props) {
	var product = props.product;

	var variant = product.variants.edges[0].node;
	return React.createElement(
		'a',
		{ href: product.onlineStoreUrl },
		product.images.edges[0] && React.createElement('img', { src: product.images.edges[0].node.productImg, alt: product.images.edges[0].node.altText }),
		React.createElement(
			'h2',
			null,
			product.title
		),
		React.createElement(
			'span',
			null,
			React.createElement(
				'strong',
				null,
				'$',
				Number(variant.priceV2.amount).toFixed(0)
			),
			variant.priceV2.currencyCode
		)
	);
};

export default Product;